import { api } from './api'

export interface Cie10Result {
  code: string
  description: string
}

export const searchCie10 = async (
  query: string,
  limit = 20,
): Promise<Cie10Result[]> => {
  if (query.length < 2) return []
  return api.get(`/cie10/search?q=${encodeURIComponent(query)}&limit=${limit}`)
}
